import { confirm, type DialogResponse } from 'owa-confirm-dialog';
import loc from 'owa-localize';
import {
    popupBlockedTitle,
    popupBlockedMessage,
    popupBlockedSettingsPrefix,
    popupBlockedEnablePopupsLinkText,
    popupBlockedSettingsSuffix,
    popupBlockedRetryButton,
} from '../utils/popupBlocked.locstring.json';

const popupBlockedSupportUrl =
    'https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5';

export default function showPopupBlockedDialog(): Promise<DialogResponse> {
    return confirm(loc(popupBlockedTitle), undefined, false, {
        useV9Dialog: true,
        okText: loc(popupBlockedRetryButton),
        bodyElement: (
            <span>
                {loc(popupBlockedMessage)}
                <br />
                <br />
                {loc(popupBlockedSettingsPrefix)}{' '}
                <a href={popupBlockedSupportUrl} target="_blank" rel="noopener noreferrer">
                    {loc(popupBlockedEnablePopupsLinkText)}
                </a>{' '}
                {loc(popupBlockedSettingsSuffix)}
            </span>
        ),
    });
}
